<template>
  <div class="page">
    <img class="img" src="../../assets/images/searchbg.png" />
    <div class="text">授权失败，无法进行医保在线结算</div>
    <div class="btn" @click="goPay">重新发起医保电子凭证授权</div>
  </div>
</template>

<script>
import { GetMedicalInsuranceUrl, GetItem, RemoveItem } from "@/services/getData.js";
export default {
  data() {
    return {};
  },
  methods: {
    goPay() {
      const  sendData = GetItem('sendData')
      GetMedicalInsuranceUrl(JSON.parse(sendData)).then(res=> {
        if(res.data.Result == false) {
          alert(res.data.Content);
          return;
        } else {
          window.location.href = res.data.Extend;
          RemoveItem('sendData')
        }
      })
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
}
.img {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
}
.text {
  margin-bottom: 50px;
  color: #4a494b;
  font-weight: 600;
  font-size: 16px;
}
.btn {
  width: 220px;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
  background: #3566e8;
  color: #fff;
  font-size: 14px;
  text-align: center;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/empowerOver/empowerOver.vue